
export const companyModel = {
  uid: null,
  name: null,
  vat_number: null,
  code_electronic_invoice: null,
  city: null,
  cap: null,
  address: null,
  email: null,
  country_company: null,
  phone: null,
  contact_name: null,
  company: 'Company',
  comanyId: 1,
  contact_surname: null,
  contact_phone: null,
  is_company: true,
  legal_privacy: false,
  commercial_privacy: false,
  give_privacy: false,
  useruid: null,
  message_mail: null,

  buildata () {
    if (!this.is_company) {
      this.name = this.contact_surname + ' ' + this.contact_name
      if (this.code_electronic_invoice === null || this.code_electronic_invoice === ' ') {
        this.code_electronic_invoice = '0000000000'
      }
      this.contact_phone = null
      this.contact_phone = this.phone
    }
  },

  costruttore (userinfo) {
    this.name = userinfo.company_id.name ?? null
    this.uid = userinfo.company_id.uid ?? null
    this.vat_number = userinfo.company_id.vat_number ?? null
    this.code_electronic_invoice = userinfo.company_id.code_electronic_invoice ?? null
    this.city = userinfo.company_id.city ?? null
    this.cap = userinfo.company_id.cap ?? null
    this.address = userinfo.company_id.address ?? null
    this.email = userinfo.email ?? null
    this.country_company = userinfo.company_id.country.uid ?? null
    this.phone = userinfo.company_id.phone ?? null
    this.contact_name = userinfo.company_id.contact_name ?? null
    this.contact_surname = userinfo.company_id.contact_surname ?? null
    this.contact_phone = userinfo.company_id.contact_phone ?? null
    this.is_company = userinfo.company_id.is_company ?? true
    this.legal_privacy = userinfo.company_id.legal_privacy ?? false
    this.commercial_privacy = userinfo.company_id.commercial_privacy ?? false
    this.give_privacy = userinfo.company_id.give_privacy ?? false
    this.uid = userinfo.company_id.uid ?? false
    this.useruid = userinfo.uid ?? null

    if (this.is_company) {
      this.comanyId = '1'
    } else {
      this.comanyId = '0'
    }
  }

}
